import React, { FC } from 'react'

import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'

import GraduationCapIcon from '@ucheba/ui/icons/icon__graduation-cap.svg'

import { Scroll, Text, BoxStyled } from '../styles'
import { useButtonHint } from '../bll'
import { IButtonHintProps } from '../types'

const ButtonHint: FC<IButtonHintProps> = (props) => {
  const { hintText } = props
  const { isOpen, onClose, handleBtnAnimation } = useButtonHint()

  if (isOpen)
    return (
      <BoxStyled color='white' spacing='xsmall'>
        <Text>
          {hintText}
          <Scroll onClick={handleBtnAnimation}>
            <GraduationCapIcon /> <span> план поступления </span>
          </Scroll>
          — список выбранных вами учебных заведений и программ. Также у нас есть сервис
          «Планировщик поступления», который поможет подобрать подходящие программы и
          получить готовый план поступления.
        </Text>

        <Spacing spacing='xxsmall' />
        <Button
          size='small'
          target='_blank'
          href='/for-abiturients/planner/about'
          color='blue'
          block
        >
          Что за планировщик?
        </Button>

        <Spacing spacing='xxsmall' />

        <Button onClick={onClose} size='small' view='outline' color='blue' block>
          Понятно
        </Button>
      </BoxStyled>
    )

  return <></>
}

export default ButtonHint
